import { QueryParamListBase } from '@shared/models';

export interface FMFListItem {
  id: number;
  patientFullname: string;
  product: 'FMF';
  institution: string;
  email: string;
  phone: string;
  date: string;
}

export interface FMFListQueryParam extends FMFListItem, QueryParamListBase {
  actions: string
}
